import { Row, Col, Space } from 'antd';
import classnames from 'classnames';
import Typography from "../typography";
import "./style";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var IglooCardGroup = function IglooCardGroup(props) {
  var children = props.children,
    subHeading = props.subHeading,
    subStatus = props.subStatus;
  var className = props.className,
    style = props.style;
  var subTitle = /*#__PURE__*/_jsxs(Space, {
    size: 8,
    style: {
      marginBottom: 16
    },
    children: [/*#__PURE__*/_jsx(Typography, {
      level: "h4",
      children: subHeading
    }), subStatus]
  });
  return subHeading || subStatus ? /*#__PURE__*/_jsxs(Row, {
    style: style,
    className: classnames('igloo-form-card-container-group-with-header', className),
    children: [/*#__PURE__*/_jsx(Col, {
      span: 24,
      children: (subHeading || subStatus) && subTitle
    }), /*#__PURE__*/_jsx(Row, {
      gutter: [32, 16],
      style: {
        width: '100%'
      },
      children: children
    })]
  }) : /*#__PURE__*/_jsx(Row, {
    gutter: [32, 16],
    style: style,
    className: classnames('igloo-form-card-container-group', className),
    children: children
  });
};
IglooCardGroup.displayName = 'IglooCardGroup';
export default IglooCardGroup;